import { Avatar } from 'components/Avatar/Avatar';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { useUserEnvironment } from 'contexts/UserEnvironmentContext';
import { useI18n } from 'i18n/hooks/useI18n';

export function CmsReactionsUserAvatar() {
  const { i18n } = useI18n();

  const { user } = useUserEnvironment();

  if (!user?.image) return null;

  return (
    <Tooltip
      variant="filled"
      content={i18n('Posting as %(name)s', { name: user?.name ?? '' })}
      placement="top-right"
      withArrow={false}
    >
      <div data-qa-id="cms-reactions-user-avatar">
        <Avatar
          image={user?.image}
          name={user?.name ?? i18n('User')}
          size="xs"
        />
      </div>
    </Tooltip>
  );
}
